import SolutionTemplate from '@LandingFunctionalDisplay/SolutionTemplate';
import { startupsData } from '@LandingFunctionalDisplay/SolutionTemplate/solutionData';

export default function StartupsPage() {
    return <SolutionTemplate {...startupsData} />;
}
